import { Box, Flex, styled } from '@withjoy/joykit';

export const Overlay = styled(Box)<{ isVisible: boolean; isExpanded?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  pointer-events: ${props => (props.isVisible ? 'auto' : 'none')};
  z-index: 999;

  @media (max-width: 768px) {
    background: ${props => (props.isExpanded ? '#00000033' : 'transparent')};
  }
`;

export const BaseSheet = styled(Box)<{ isVisible: boolean }>`
  position: relative;
  background: rgba(251, 251, 251, 0.8);
  border-radius: 24px 24px 0px 0px;
  border: 1px solid #fbfbfb;
  box-shadow: 0px 10px 60px -20px rgba(0, 0, 0, 0.12), 0px 10px 60px -20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  overflow: hidden;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  > * {
    position: relative;
    z-index: 1;
  }
`;

export const MobileSheet = styled(BaseSheet)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(${props => (props.isVisible ? '0' : '100%')});
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  transition: transform 0.5s cubic-bezier(0.2, 0, 0, 1);
  will-change: transform;
`;

type DesktopPopupPosition = 'top-right' | 'bottom-right';

export const DesktopPopup = styled(BaseSheet)<{ isVisible: boolean; position?: DesktopPopupPosition }>`
  position: fixed;
  ${props =>
    props.position === 'bottom-right'
      ? `
    bottom: 40px;
    right: 40px;
  `
      : `
    top: 40px;
    right: 40px;
  `}
  width: 394px;
  border-radius: 24px;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transform: translateY(${props => (props.isVisible ? '0' : '-20px')});
  transition: all 0.5s cubic-bezier(0.2, 0, 0, 1);
  pointer-events: ${props => (props.isVisible ? 'auto' : 'none')};
  will-change: transform, opacity;
`;

export const ExpandedMobileSheet = styled(BaseSheet)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(${props => (props.isVisible ? '0' : '100%')});
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  transition: transform 0.5s cubic-bezier(0.2, 0, 0, 1);
  will-change: transform;
`;

export const ExpandedDesktopPopup = styled(BaseSheet)<{ isVisible: boolean; position?: DesktopPopupPosition }>`
  position: fixed;
  ${props =>
    props.position === 'bottom-right'
      ? `
    bottom: 40px;
    right: 40px;
  `
      : `
    top: 40px;
    right: 40px;
  `}
  width: 394px;
  border-radius: 24px;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transform: translateX(${props => (props.isVisible ? '0' : '100%')});
  transition: all 0.5s cubic-bezier(0.2, 0, 0, 1);
  pointer-events: ${props => (props.isVisible ? 'auto' : 'none')};
  will-change: transform, opacity;
`;

export const ClickableArea = styled(Flex)`
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

export const TitleGradient = styled.span`
  background: linear-gradient(90deg, #0ca599 0%, #4951ef 50%, #ba2bc4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;
